module.exports = __webpack_public_path__ + "static/05-8db339c75e3818e27486c3d33450f8bf.jpg";